module.exports = __webpack_public_path__ + "static/media/splash3_2x.7fe66af2.jpg";